
import { Injectable } from '@angular/core';
import { filterAllTruthyInTuple } from 'core/rx-js';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { IPageInfo, PdfViewerService } from '../../pdf-viewer.service';
import { IPdfDocumentInput } from '../../types';
import { PdfThumbnailViewportsContainerService } from '../pdf-thumbnail-viewports-container/pdf-thumbnail-viewports-container.service';

@Injectable()
export class PdfThumbnailViewportService {

  // private readonly _destroy = new Subject<void>();

  // readonly PADDING = 10;
  // readonly BORDER = 1;
  // readonly BOTTOM_MARGIN = 5;

  // readonly selectedPageSubject = this._pdfViewerService.selectedPageSubject;
  readonly pdfDocumentSubject = new BehaviorSubject<IPdfDocumentInput>(undefined);
  // readonly virtualViewportSubject = new BehaviorSubject<CdkVirtualScrollViewport>(undefined)
  // readonly virtualScrollableSubject = this._pdfThumbnailViewportsContainerService.virtualScrollableSubject;

  // readonly sidebarOpenedSubject = this._pdfViewerService.sidebarOpenedSubject.pipe(debounceTime(200));
  // readonly pdfThumbnailViewportHeightsSubject = this._pdfThumbnailViewportsContainerService.pdfThumbnailViewportHeightsSubject;

  // readonly widthSubject = new BehaviorSubject<number>(200);

  // readonly firstPageProxyObs = this.pdfDocumentSubject.pipe(
  //   map((pdfDocument) => pdfDocument?.pdfDocumentProxy),
  //   filter(Boolean),
  //   distinctUntilChanged(),
  //   switchMap((pdfDocumentProxy) =>
  //     from(pdfDocumentProxy.getPage(1)).pipe(take(1))
  //   )
  // )

  // readonly scaleObs = combineLatest([this.firstPageProxyObs, this.widthSubject])
  //   .pipe(
  //     map(([firstPageProxy, width]) => {
  //       const viewport = firstPageProxy.getViewport({ scale: 1 });
  //       const scale = width / viewport.width
  //       return Math.round(scale * 100) / 100
  //     }),
  //     distinctUntilChanged()
  //   )


  // readonly canvasHeightObs = combineLatest([
  //   this.firstPageProxyObs,
  //   this.scaleObs
  // ])
  //   .pipe(
  //     map(([firstPageProxy, scale]) => {

  //       const viewport = firstPageProxy.getViewport({ scale: 1 });
  //       const calculatedHeight = Math.round(viewport.height * scale);
  //       return calculatedHeight;
  //     }),
  //     startWith(0)
  //   )

  // readonly virtualElementHeightObs = this.canvasHeightObs.pipe(
  //   map(canvasHeight => {
  //     if (!canvasHeight) {
  //       return 0;
  //     }

  //     return canvasHeight + this.PADDING * 2 + this.BORDER * 2 + this.BOTTOM_MARGIN
  //   })
  // )


  // readonly renderedRangeObs = this.virtualViewportSubject
  //   .pipe(
  //     filter(Boolean),
  //     switchMap((virtualViewport) =>
  //       virtualViewport.renderedRangeStream
  //         .pipe(
  //           debounceTime(20),
  //           startWith(virtualViewport.getRenderedRange())
  //         )
  //     ),
  //     distinctUntilChanged(({ end: prevEnd, start: prevStart }, { end, start }) => end === prevEnd && start === prevStart),
  //     map((({ end, start }) => ({ start: start || 0, end }))),

  //   )  
  readonly scaledPdfPageInfosSubject = this._pdfThumbnailViewportsContainerService.scaledPdfPageInfosSubject;
  readonly pageInfosObs = combineLatest([this.pdfDocumentSubject, this.scaledPdfPageInfosSubject])
    .pipe(
      filterAllTruthyInTuple(),
      map(([pdfDocument, scaledPdfPageInfos]) => scaledPdfPageInfos.filter(({ docId }) => pdfDocument.id === docId))
    )

  readonly viewerScrollTopSubject = this._pdfViewerService.scrollTopSubject;
  readonly thumbnailScrollTopSubject = this._pdfViewerService.scrollTopSubject;

  get viewerPageInfos() {
    return this._pdfViewerService.pdfPageInfos
  }

  get thumbnailPageInfos() {
    return this._pdfThumbnailViewportsContainerService.scaledPdfPageInfosSubject.value;
  }

  readonly visiblePageRangeSubject = this._pdfThumbnailViewportsContainerService.visiblePageRangeSubject;
  constructor(
    private _pdfViewerService: PdfViewerService,
    private _pdfThumbnailViewportsContainerService: PdfThumbnailViewportsContainerService
  ) {
  }




  //   combineLatest([
  //     this.pdfDocumentSubject,
  //     this.virtualElementHeightObs
  //   ])
  //     .pipe(
  //       takeUntil(this._destroy),
  //       filterAllTruthyInTuple(),
  //     )
  //     .subscribe(([pdfDocument, thumbnailHeight]) => {
  //       const prevHeights = this.pdfThumbnailViewportHeightsSubject.value;

  //       this.pdfThumbnailViewportHeightsSubject.next({
  //         ...prevHeights,
  //         [pdfDocument.id]: thumbnailHeight + 5
  //       })
  //     })
  // }

  // async renderPage(canvasElement: HTMLCanvasElement, divOverlay: HTMLDivElement, pageIdx: number) {

  //   if (!canvasElement) {
  //     return;
  //   }

  //   const pdfDocumentProxy = this.pdfDocumentSubject.value?.pdfDocumentProxy;

  //   if (!pdfDocumentProxy) {
  //     return;
  //   }

  //   const pdfPage = await pdfDocumentProxy.getPage(pageIdx);

  //   const viewPortWidth = pdfPage.getViewport({ scale: 1 }).width;
  //   const maxWidth = 180;
  //   const viewPort = pdfPage.getViewport({ scale: maxWidth / viewPortWidth });

  //   const ctx = canvasElement.getContext('2d');

  //   canvasElement.height = viewPort.height;
  //   canvasElement.width = viewPort.width;
  //   // canvasElement.style.width = canvasElement.width + 'px'
  //   // canvasElement.style.height = canvasElement.height + 'px'

  //   //todo
  //   const offset = 22;

  //   divOverlay.style.width = (offset + canvasElement.width) + 'px';
  //   divOverlay.style.height = (offset + canvasElement.height) + 'px';

  //   if (!ctx) {
  //     return
  //   }

  //   // pdfPage.render({
  //   //   canvasContext: ctx,
  //   //   viewport: viewPort,
  //   // })

  // }

  selectPage(pageInfo: IPageInfo) {

    const page = this.viewerPageInfos.find((page) => page.pageIdx === pageInfo.pageIdx)
    this.viewerScrollTopSubject.next(page.scrollTop);
  }
}
